import { render, staticRenderFns } from "./DiscountsBreakdown.vue?vue&type=template&id=d0b6d546&lang=pug"
import script from "./DiscountsBreakdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscountsBreakdown.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports